import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-circle-chart-info',
  templateUrl: './circle-chart-info.component.html',
  styleUrls: ['./circle-chart-info.component.scss']
})
export class CircleChartInfoComponent {
  @Input() infoTitle: string;
  @Input() infoValue: string;
  @Input() infoLabel: string;
}
